var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.73,
    height: 12.73
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8e8e95",
    d: "M5.658.71a1 1 0 011.415 0l4.95 4.95a1 1 0 010 1.414 1 1 0 01-1.415 0L6.365 2.83 2.123 7.074a1 1 0 01-1.414 0 1 1 0 010-1.414z"
  })));
}
export default SvgArrowGrey;